var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isEmpty, pickBy } from 'ramda';
import { parse, stringify } from 'querystringify';
import { filterEmptyValues } from 'utils/objectHelper';
import { queryObjectValue, unstringifyBooleanValues } from './helpers';
function asFilters(state) {
    return state;
}
var FilterSystem = function (_a) {
    var _b = _a.defaults, defaults = _b === void 0 ? {} : _b, _c = _a.lockUrl, lockUrl = _c === void 0 ? false : _c, children = _a.children;
    var _d = useLocation(), pathname = _d.pathname, search = _d.search;
    var navigate = useNavigate();
    var _e = useState(function () {
        return asFilters(unstringifyBooleanValues(__assign(__assign({}, defaults), parse(search))));
    }), queryObject = _e[0], setQueryObject = _e[1];
    var updateQueryString = function (state) {
        if (lockUrl)
            return;
        var args = filterEmptyValues(state !== null && state !== void 0 ? state : {});
        navigate("".concat(pathname, "?").concat(stringify(args, false)));
    };
    var updateFilters = function (key, value) {
        var _a;
        var newState = filterEmptyValues(__assign(__assign({}, queryObject), (_a = {}, _a[key] = queryObjectValue(value), _a)));
        updateQueryString(newState);
        setQueryObject(newState);
        return newState;
    };
    var updateSeveralFilters = function (changes, pruneEmptyKeys) {
        if (pruneEmptyKeys === void 0) { pruneEmptyKeys = false; }
        var base = pruneEmptyKeys
            ? pickBy(Boolean, queryObject)
            : queryObject;
        var applied = changes.flatMap(function (change) {
            return Object.entries(change).map(function (_a) {
                var key = _a[0], value = _a[1];
                return [
                    key,
                    queryObjectValue(value)
                ];
            });
        });
        var newState = __assign(__assign({}, base), Object.fromEntries(applied));
        updateQueryString(newState);
        setQueryObject(newState);
        return newState;
    };
    var setFilters = function (values) {
        updateQueryString(values);
        setQueryObject(values !== null && values !== void 0 ? values : asFilters({}));
    };
    var resetFilters = function (defaultQuery) {
        updateQueryString(null);
        setQueryObject(defaultQuery !== null && defaultQuery !== void 0 ? defaultQuery : asFilters({}));
    };
    useEffect(function () {
        if (!isEmpty(defaults) && !search)
            updateQueryString(defaults);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (_jsx(_Fragment, { children: children(queryObject, updateFilters, updateSeveralFilters, setFilters, resetFilters) }));
};
export default FilterSystem;
